<template>
  <div class="roxxrt_container">
    <div class="roxxrt_container__flex">
      <!--
        提携先ロゴ。DownloadItem では長く v-if="false" だったが 2026-09-15 の
        ae545f17 で復活したため、完了画面リニューアル側にも持ち込む。
      -->
      <img
        v-if="info.logoImage"
        :src="info.logoImage"
        alt="Yagish*"
        class="roxxrt_img"
        @load="onLogoLoad"
      />
      <p class="roxxrt_txt">
        <template v-if="!info.hide_yagish_terms">
          Yagishの<router-link
            id="footer-link-terms"
            :to="{ name: 'termsPage' }"
            target="_blank"
            >利用規約</router-link
          >、<router-link
            id="footer-link-policy"
            :to="{ name: 'policyPage' }"
            target="_blank"
            >個人情報保護方針</router-link
          >、<a href="https://www.yagish.jp/privacy_policy/" target="_blank"
            >プライバシーポリシー</a
          ><br />
        </template>
        <span v-if="hasPartnerTerms" v-html="partnerTermsHtml" />
        <template v-else>
          {{ info.clientName }}の<a :href="info.termurl" target="_blank"
            >利用規約</a
          >、<a :href="info.privacyurl" target="_blank">{{
            info.privacyLabel || '個人情報保護方針'
          }}</a
          ><a v-if="info.handlingurl" :href="info.handlingurl" target="_blank"
            >、個人情報の取扱い</a
          ><a
            v-if="info.occupationurl"
            :href="info.occupationurl"
            target="_blank"
            >、取扱職種の範囲等の明示</a
          >を確認して{{ info.clientServiceName }}に登録することになります。
        </template>
        <br v-if="info.showTrailingBr" />
        ※ご経験やスキルに応じて求人をご案内する場合があります
      </p>
    </div>
    <p class="roxxrt_container__txt">
      <el-checkbox
        class="rt-agree-checkbox"
        :value="agreed"
        @change="emit('update:agreed', $event === true)"
      />
      &#x3000;規約に同意して無料相談を希望する
    </p>
  </div>
</template>

<script setup lang="ts">
/**
 * auto_rt（完了画面の自動送客）の同意ブロック。DownloadItem.vue から文言ごと移設した。
 * 表示条件・同意状態の正本は useCompletedOutput 側（このコンポーネントは presentational）。
 */
import { reportImageCacheStat } from '@/utils/image-cache-stats'

const props = defineProps<{
  /** autoRtState.info（クライアント名・規約 URL など） */
  info: Record<string, any>
  hasPartnerTerms: boolean
  partnerTermsHtml: string
  agreed: boolean
}>()

const emit = defineEmits<{ (e: 'update:agreed', value: boolean): void }>()

/** ロゴがキャッシュ/SW/ネットワークのどこから来たかを Whatap へ送る（DownloadItem から移設） */
function onLogoLoad(event: Event) {
  reportImageCacheStat(event.target as HTMLImageElement, {
    dialogName: 'auto_rt',
    clientId: props.info.clientId,
    permissionType: props.info.permissionType
  })
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';

.roxxrt_container {
  text-align: center;
  font-size: 12px;

  @include max-width(sm) {
    font-size: 11px;
  }

  &__txt {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1.4;

    // チェックボックス自体のスケール（インライン scale(1.4) で大きすぎていたものを縮小）
    .rt-agree-checkbox {
      transform: scale(0.9);
      transform-origin: right center;
      margin-right: 2px;

      @include max-width(sm) {
        transform: scale(0.85);
      }

      // チェック状態の色をプロジェクトテーマのピンクからグレーに上書き（scoped 配下のため :deep()）
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
      :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
        background-color: #909399;
        border-color: #909399;
      }

      // フォーカス時の枠線色もグレーに合わせる
      :deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
        border-color: #909399;
      }

      // ラベル文字色がチェック時にピンクへ変わる挙動も無効化
      :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: inherit;
      }
    }
  }

  &__flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 4px 0 0;
    width: 90%;
    margin: 0 auto;

    @include max-width(sm) {
      padding: 4px 8px 0;
      width: 100%;
      gap: 8px;
    }

    .roxxrt_img {
      width: calc(50% - 6px);
      max-width: 220px;

      @include max-width(sm) {
        width: 100%;
        max-width: 180px;
      }
    }

    .roxxrt_txt {
      width: 100%;
      text-align: left;
      font-size: 11px;
      line-height: 1.5;

      @include max-width(sm) {
        font-size: 10px;
      }
    }
  }
}
</style>
